// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"275b826c","290":"54583323","433":"3912f4f9","631":"89dd9aaa","637":"630218cb","768":"c0b0a7de","886":"8c1f89f0"}[chunkId] + ".chunk.js";
};